export default function useConfig(index = 0) {
  const config = {
      "program": "NEW PROGRAM",
      "buckets": [
        {
          "filter": { "frequency": 500, "Q": 1, "type": "bandpass" },
          "compressor": {
            "threshold": -20,
            "knee": 5,
            "ratio": 10,
            "attack": 0.15,
            "release": 0.15
          }
        },
        {
          "filter": { "frequency": 4000, "Q": 2, "type": "bandpass" },
          "compressor": {
            "threshold": -60,
            "knee": 1,
            "ratio": 10,
            "attack": 0.01,
            "release": 0.01
          }
        },
        {
          "filter": { "frequency": 8000, "Q": 4, "type": "highpass" },
          "compressor": {
            "threshold": -60,
            "knee": 1,
            "ratio": 10,
            "attack": 0.01,
            "release": 0.01
          }
        }
      ],
      "input": "FILE",
      "deviceId": null,
      "file": "/sub-tribuo.mp3"
    }

  return {
    config,
  };
}
